/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://27qyqpkpn6.execute-api.eu-north-1.amazonaws.com/dev",
            "region": "eu-north-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://w5jzlgblbbgb3nz7mzxoknumjq.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-north-1:e7f97da4-239b-424d-8873-1aabf3db78a8",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_XCqDyJSbX",
    "aws_user_pools_web_client_id": "5pnb890s2lskmv03a8prpuhu9n",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "likabehandlignsplan-hosting-dev",
    "aws_content_delivery_bucket_region": "eu-north-1",
    "aws_content_delivery_url": "https://d1wpk1hemm054t.cloudfront.net",
    "aws_user_files_s3_bucket": "likabehandlingsplan39effe698d494957a569d444d56b114611-dev",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
